const _0x9e7f = () => {
  const _0xd = 87;
  const _0xe = 88;
  const _0xf = 53;
  const _0x10 = 85;
  const _0x11 = 50;
  return String.fromCharCode(_0xd, _0xe, _0xf, _0x10, _0x11);
};

export const FD = _0x9e7f;
